// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"393630ea","453":"f0b5451f","797":"187e31fc","947":"d02e51cb"}[chunkId] + ".chunk.js";
};